import $ from 'jquery'
import bomLocations from './constants/cities'
import {
  fetchLocation,
  fetchWeatherOverview,
  calcClosestCityAndWeather,
  getForecastTimeString,
  getTemperatureString,
  addDistKeyToLocations,
  getClosestCity,
  loadedLocation,
  loadedWeather,
  // location,
  cityWeather,
  weather,
  getPriority,
} from './activities'
import { capitalizeFirstLetter } from './utils/stringUtils'

let $weatherOverviewSections = []
let intervalRef = null

export function init() {
  $weatherOverviewSections = $('[data-weather-overview]')
  if (!$weatherOverviewSections.length) return
  if (!loadedLocation || !loadedWeather) {
    fetchLocation()
      .then(fetchWeatherOverview)
      .then(calcClosestCityAndWeather)
      .then(() => initSections())
  } else {
    initSections()
  }

  if (!intervalRef) intervalRef = setInterval(init, 1000 * 60)
}

export function initSections() {
  if (!$weatherOverviewSections.length) return
  $weatherOverviewSections.each((i, elem) => {
    const $weatherOverviewSection = $(elem)
    const selectedCityNames = $weatherOverviewSection.data('weather-overview-cities') || []
    const allCities = !selectedCityNames.length
    const filteredCityWeather = allCities
      ? [...cityWeather]
      : cityWeather.filter(({ name }) => selectedCityNames.indexOf(name) >= 0)
    $weatherOverviewSection.html('')
    filteredCityWeather.forEach((currentCityWeather) => {
      const { name, coord } = currentCityWeather
      const { id, icon, description } = currentCityWeather.weather[0] || {}
      const { temp_min, temp_max } = currentCityWeather.main

      const closestBomLocation = getClosestCity(addDistKeyToLocations(bomLocations, coord.lat, coord.lon))
      const isActive = name == weather.name
      const bomUrl = closestBomLocation.bom
      const priority = getPriority(id)

      let itemHtml = `<a href="${bomUrl}" class="weather-overview-city ${isActive ? 'active' : ''}">`
      itemHtml += `<div class="weather-overview-city-name" data-city-name><h6>${name}</h6></div>`
      itemHtml += `<div class="weather-overview-city-time" data-city-time>${getForecastTimeString(name)}</div>`
      itemHtml += `<div class="weather-overview-city-temperature" data-city-temperature>${getTemperatureString(
        temp_min,
        temp_max
      )}</div>`
      itemHtml += `<div class="weather-overview-city-status text-${
        priority == 'alert' ? 'error' : priority
      }" data-city-status>${capitalizeFirstLetter(description)}</div>`
      itemHtml += `<div class="weather-overview-city-icon" data-city-icon><img src="https://openweathermap.org/img/w/${icon}.png" /></div>`
      itemHtml += `</a>`
      const $item = $(itemHtml)
      $item.appendTo($weatherOverviewSection)
    })
  })
}
